import { Injectable } from '@angular/core';

declare global {
  interface Window {
    __ENV: {
      production: boolean;
      apiUrl: string;
      proxyUrl: string;
      geoserverUrl: string;
      arcgisPrintServiceUrl: string;
      appName: string;
      version: string;
    };
  }
}

@Injectable({ providedIn: 'root' })
export class ConfigService {
  private get env() {
    // ❌ SIN fallback: Si window.__ENV no existe, lanzamos error explícito
    if (!window.__ENV) {
      throw new Error(
        '⚠️ ConfigService: window.__ENV no está definido. ' +
        '¿Olvidaste cargar assets/env.js en index.html o generar el archivo en Docker?'
      );
    }
    return window.__ENV;
  }

  get isProduction(): boolean {
    return this.env.production === true;
  }

  get apiUrl(): string {
    return this.env.apiUrl;
  }
  get proxyUrl(): string {
    return this.env.proxyUrl;
  }

  get geoserverUrl(): string {
    return this.env.geoserverUrl;
  }

  get arcgisPrintServiceUrl(): string {
    return this.env.arcgisPrintServiceUrl;
  }

  get appName(): string {
    return this.env.appName;
  }

  get version(): string {
    return this.env.version;
  }
}